var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNurseReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3425 6.46826L13.0975 14.0375H10.9082L10.6632 6.46826H13.3425ZM12.0002 17.5318C11.6202 17.5318 11.2935 17.3969 11.0201 17.127C10.7502 16.8571 10.6152 16.5304 10.6152 16.1469C10.6152 15.7705 10.7502 15.4491 11.0201 15.1828C11.2935 14.9129 11.6202 14.7779 12.0002 14.7779C12.3659 14.7779 12.6873 14.9129 12.9643 15.1828C13.2449 15.4491 13.3851 15.7705 13.3851 16.1469C13.3851 16.4026 13.3194 16.6352 13.188 16.8447C13.0602 17.0542 12.8915 17.2211 12.682 17.3454C12.476 17.4697 12.2488 17.5318 12.0002 17.5318Z",
    fill: "#1E233E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseReview);
export default __webpack_public_path__ + "static/media/nurse-review.961395b5c6e907fb0118c5710cae5413.svg";
export { ForwardRef as ReactComponent };